<h1 mat-dialog-title *ngIf="data.title">{{ data.title }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.content"></p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button class="btn w-100" color="primary" (click)="click()">
    {{ data.button }}
  </button>
</div>
